<div class="left-sidenav" id="accordionExample">
  <div class="main-menu-inner">
    <div class="menu-body sidebar-nav">
      <ul class="nav" data-widget="treeview" role="menu" data-accordion="false">
        <li
          class="nav-item"
          *hasClaim="[
            'DB_STATISTICS',
            'DB_BEST_SELLING_PROS',
            'DB_REMINDERS',
            'DB_LATEST_INQUIRIES',
            'DB_RECENT_SO_SHIPMENT',
            'DB_RECENT_PO_DELIVERY'
          ]"
        >
          <a
            [routerLink]="['/']"
            [ngClass]="{ active: currentUrl == 'dashboard' }"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link"
          >
            <i class="nav-icon fas fa-tachometer-alt"></i>
            <p>
              {{ "DASHBOARD" | translate }}
            </p>
          </a>
        </li>
        <li
          id="ProductHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          data-target="#ProductCategory"
          class="collapsed"
          *hasClaim="[
            'PRO_VIEW_PRODUCTS',
            'PRO_ADD_PRODUCT',
            'PRO_MANAGE_PRO_CAT',
            'PRO_MANAGE_BRAND',
            'PRO_MANAGE_WAREHOUSE',
            'BROWSE_CATEGORY',
            'PRODUCT_TYPE_LIST',
            'PRO_MANAGE_FRAME',
            'SPECIALPRICING_LIST',
            'RELATEDPRODUCT_LIST'
          ]"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'product' }">
            <i class="nav-icon fas fa-cubes"></i>
            <span>{{ "PRODUCT" | translate }} </span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          [ngClass]="{ show: currentUrl == 'product' }"
          id="ProductCategory"
          aria-labelledby="ProductHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'BROWSE_CATEGORY'" class="nav-item">
            <a
              [routerLink]="['/items']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Browse Category</p>
            </a>
          </li>
          <li *hasClaim="'PRO_VIEW_PRODUCTS'" class="nav-item">
            <a
              [routerLink]="['/products']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'PRO_ADD_PRODUCT'" class="nav-item">
            <a
              [routerLink]="['/products/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'PRO_MANAGE_PRO_CAT'" class="nav-item">
            <a
              [routerLink]="['/product-category']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Category</p>
            </a>
          </li>
          <!-- <li  style="background-color: gray;" *hasClaim="'PRO_MANAGE_PRO_CAT'" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>Related Products</p>
            </a>
          </li>
          <li  style="background-color: gray;" *hasClaim="'PRO_MANAGE_PRO_CAT'" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>Volume Pricing</p>
            </a>
          </li>
          <li  style="background-color: gray;" *hasClaim="'PRO_MANAGE_PRO_CAT'" class="nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>Modifier Lists</p>
            </a>
          </li>
          <li  style="background-color: gray;" *hasClaim="'PRO_MANAGE_PRO_CAT'" class="nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>Modifier List Items </p>
            </a>
          </li>
          <li style="background-color: gray;" *hasClaim="'PRO_MANAGE_PRO_CAT'" class="nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>Product Modifier</p>
            </a>
          </li>
          <li style="background-color: gray;" *hasClaim="'PRO_MANAGE_PRO_CAT'" class="nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>Customer Special Pricing</p>
            </a>
          </li>
          <li style="background-color: gray;" *hasClaim="'PRO_MANAGE_PRO_CAT'" class="nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>Duplicate</p>
            </a>
          </li> -->
          <li class="nav-item" *hasClaim="'PRO_MANAGE_FRAME'">
            <a
              [routerLink]="['/product-frame']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Product Frame</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'PRODUCT_TYPE_LIST'">
            <a
              [routerLink]="['/product-type']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Product Type</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'SPECIALPRICING_LIST'">
            <a
              [routerLink]="['/customer-special-pricing']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Special Pricing</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'SPECIALPRICING_LIST'">
            <a
              [routerLink]="['/product-volume-pricing']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Volume Pricing</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'RELATEDPRODUCT_LIST'">
            <a
              [routerLink]="['/related-products']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Related Products</p>
            </a>
          </li>
          <!-- <li style="background-color: red;" *hasClaim="'PRO_MANAGE_BRAND'" class="nav-item">
            <a [routerLink]="['/brand']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{'BRAND' | translate}}</p>
            </a>
          </li>
          <li  style="background-color: red;" *hasClaim="'PRO_MANAGE_WAREHOUSE'" class="nav-item">
            <a [routerLink]="['/warehouse']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{'WAREHOUSE' | translate}}</p>
            </a>
          </li> -->
        </ul>
        <!-- <li style="background-color: red;"  id="SupplierHeading" aria-expanded="true" aria-controls="collapseOne"
          *hasClaim="['SUPP_VIEW_SUPPLIERS','SUPP_ADD_SUPPLIER']" data-toggle="collapse" data-target="#Supplier"
          class="collapsed">
          <a class="nav-link" [ngClass]="{'active': currentUrl == 'supplier'}">
            <i class="nav-icon fas fa-truck"></i>
            <span>{{'SUPPLIER' | translate}}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li> -->
        <ul
          class="sub-menu collapse"
          [ngClass]="{ show: currentUrl == 'supplier' }"
          id="Supplier"
          aria-labelledby="SupplierHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'SUPP_VIEW_SUPPLIERS'" class="nav-item">
            <a
              [routerLink]="['/supplier']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'SUPP_ADD_SUPPLIER'" class="nav-item">
            <a
              [routerLink]="['/supplier/manage/addItem']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>
        <li
          id="GenerateLabelsHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          data-target="#labels"
          class="collapsed"
          *hasClaim="['LABELS_LIST', 'MANAGE_LABELS']"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'labels' }">
            <i class="fas fa-qrcode"></i>
            <span>Label</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>

        <ul
          class="sub-menu collapse"
          id="labels"
          [ngClass]="{ show: currentUrl == 'labels' }"
          aria-labelledby="LabelsHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'LABELS_LIST'" class="nav-item">
            <a
              [routerLink]="['/labels/labels']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'MANAGE_LABELS'" class="nav-item">
            <a
              [routerLink]="['/labels/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>
        <li
          id="TagsHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          data-target="#Tags"
          class="collapsed"
          *hasClaim="[
            'PRO_MANAGE_PRODUCT_TAGS',
            'QUICK_EDIT_TAGS',
            'QUICK_EDIT_TAG_ITEMS'
          ]"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'tags' }">
            <i class="far fa-list-alt nav-icon"></i>
            <span>Tags</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Tags"
          [ngClass]="{ show: currentUrl == 'tags' }"
          aria-labelledby="TerritoriesHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'QUICK_EDIT_TAGS'" class="nav-item">
            <a
              [routerLink]="['/tags/list']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'QUICK_EDIT_TAG_ITEMS'" class="nav-item">
            <a
              [routerLink]="['/tags/add-tag']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'QUICK_EDIT_TAG_ITEMS'" class="nav-item">
            <a
              [routerLink]="['/tags/manage-tags']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              Manage
            </a>
          </li>
          <li *hasClaim="'QUICK_EDIT_TAG_ITEMS'" class="nav-item">
            <a
              [routerLink]="['/tags/assign-tags-list']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              Assign
            </a>
          </li>
        </ul>
        <li
          id="DiscountHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['VIEW_DISCOUNT', 'MANAGE_DISCOUNT']"
          data-toggle="collapse"
          data-target="#Discounts"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'discounts' }">
            <i class="nav-icon fas fa-percent"></i>
            <span>Discounts</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Discounts"
          [ngClass]="{ show: currentUrl == 'discounts' }"
          aria-labelledby="TerritoriesHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'VIEW_DISCOUNT'" class="nav-item">
            <a
              [routerLink]="['/discounts']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'MANAGE_DISCOUNT'" class="nav-item">
            <a
              [routerLink]="['/discounts/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>

        <li
          id="ShippingHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          *hasClaim="['VIEW_DISCOUNT']"
          data-target="#ShippingCost"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'shipping-cost' }">
            <i class="nav-icon fas fa-percent"></i>
            <span>Shipping Cost</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="ShippingCost"
          [ngClass]="{ show: currentUrl == 'shipping-cost' }"
          aria-labelledby="ShippingHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'VIEW_DISCOUNT'" class="nav-item">
            <a
              [routerLink]="['/shipping-cost']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
        </ul>

        <li
          id="UpChargeHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['VIEW_UPCHARGE', 'MANAGE_UPCHARGE']"
          data-toggle="collapse"
          data-target="#UpCharge"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'up-charge' }">
            <i class="nav-icon fas fa-users-cog"></i>
            <span>Up-Charge</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="UpCharge"
          [ngClass]="{ show: currentUrl == 'up-charge' }"
          aria-labelledby="UpChargeHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'VIEW_UPCHARGE'" class="nav-item">
            <a
              [routerLink]="['/up-charge']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'MANAGE_UPCHARGE'" class="nav-item">
            <a
              [routerLink]="['/up-charge/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>

        <li
          id="BestSellingHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['BEST_SELLING_CATEGORY']"
          data-toggle="collapse"
          data-target="#BestSelling"
          class="collapsed"
        >
          <a
            class="nav-link"
            [ngClass]="{ active: currentUrl == 'best-selling-category' }"
          >
            <i class="nav-icon fas fa-percent"></i>
            <span>Best Selling Category</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>

        <ul
          class="sub-menu collapse"
          id="BestSelling"
          [ngClass]="{ show: currentUrl == 'best-selling-category' }"
          aria-labelledby="BestSellingHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'BEST_SELLING_CATEGORY'" class="nav-item">
            <a
              [routerLink]="['/best-selling-category']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
        </ul>

        <li
          id="BestSellingProductHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['BEST_SELLING_PRODUCT']"
          data-toggle="collapse"
          data-target="#BestSellingProduct"
          class="collapsed"
        >
          <a
            class="nav-link"
            [ngClass]="{ active: currentUrl == 'best-selling-product' }"
          >
            <i class="nav-icon fas fa-percent"></i>
            <span>Best Selling Product</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>

        <ul
          class="sub-menu collapse"
          id="BestSellingProduct"
          [ngClass]="{ show: currentUrl == 'best-selling-product' }"
          aria-labelledby="BestSellingProductHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'BEST_SELLING_PRODUCT'" class="nav-item">
            <a
              [routerLink]="['/best-selling-product']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
        </ul>

        <li
          id="CustomerHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['CUST_VIEW_CUSTOMERS', 'CUST_ADD_CUSTOMER']"
          data-toggle="collapse"
          data-target="#Customer"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'customer' }">
            <i class="nav-icon fas fa-users-cog"></i>
            <span>{{ "CUSTOMER" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Customer"
          [ngClass]="{ show: currentUrl == 'customer' }"
          aria-labelledby="CustomerHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'CUST_VIEW_CUSTOMERS'" class="nav-item">
            <a
              [routerLink]="['/customer']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'CUST_ADD_CUSTOMER'" class="nav-item">
            <a
              [routerLink]="['/customer/addItem']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'CUSTOMER_APPROVAL'" class="nav-item">
            <a
              [routerLink]="['/customer/approval']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Customer Approval</p>
            </a>
          </li>
          <li *hasClaim="'CUST_ADD_CUSTOMER'" class="nav-item">
            <a
              [routerLink]="['/customer/shipto']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Ship To's</p>
            </a>
          </li>
          <li *hasClaim="'CUST_ADD_CUSTOMER'" class="nav-item">
            <a
              [routerLink]="['/customer/duplicate-customers']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Duplicate Customer</p>
            </a>
          </li>
          <!-- <li style="background-color: gray;" *hasClaim="'CUST_ADD_CUSTOMER'" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Merge Customer</p>
            </a>
          </li>
          <li style="background-color: gray;" *hasClaim="'CUST_ADD_CUSTOMER'" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Duplicate</p>
            </a>
          </li> -->
        </ul>
        <li
          id="TerritoriesHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['PRO_VIEW_TERRITORIES', 'PRO_ADD_TERRITORIES']"
          data-toggle="collapse"
          data-target="#Territories"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'territory' }">
            <i class="nav-icon fas fa-users-cog"></i>
            <span>Territories</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Territories"
          [ngClass]="{ show: currentUrl == 'territory' }"
          aria-labelledby="TerritoriesHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'PRO_VIEW_TERRITORIES'" class="nav-item">
            <a
              [routerLink]="['/territory']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'PRO_ADD_TERRITORIES'" class="nav-item">
            <a
              [routerLink]="['/territory/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>

        <li
          id="BookmarksHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          data-target="#Bookmarks"
          class="collapsed"
          *hasClaim="'BM_VIEW_BOOKMARKS'"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'bookmarks' }">
            <i class="nav-icon fas fa-bookmark"></i>
            <span>Bookmarks</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Bookmarks"
          [ngClass]="{ show: currentUrl == 'bookmarks' }"
          aria-labelledby="BookmarksHeading"
          data-parent="#accordionExample"
        >
          <li class="nav-item" *hasClaim="'BM_VIEW_BOOKMARKS'">
            <a
              [routerLink]="['/bookmarks']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
        </ul>

        <!-- <li  style="background-color: gray;" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="far fa-list-alt nav-icon"></i>
            <p>Showroom Activity</p>
          </a>
        </li>
        <li  style="background-color: gray;" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="far fa-list-alt nav-icon"></i>
            <p>FlipBooks</p>
          </a>
        </li>
        <li  style="background-color: gray;" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="far fa-list-alt nav-icon"></i>
            <p>Tag Management and Look Books</p>
          </a>
        </li>
        <li  style="background-color: gray;" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="far fa-list-alt nav-icon"></i>
            <p>Commission Management</p>
          </a>
        </li>
        <li  style="background-color: gray;" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="far fa-list-alt nav-icon"></i>
            <p>Commission Spilliting</p>
          </a>
        </li>
        <li  style="background-color: gray;" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="far fa-list-alt nav-icon"></i>
            <p>Best Selling Series and Collections</p>
          </a>
        </li> -->
        <li
          id="SalesRepHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['VIEW_SALES_REPS', 'ADD_SALES_REPS']"
          data-toggle="collapse"
          data-target="#SalesReps"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'salesreps' }">
            <i class="nav-icon fas fa-users-cog"></i>
            <span>Sales Reps</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="SalesReps"
          [ngClass]="{ show: currentUrl == 'salesreps' }"
          aria-labelledby="SalesRepsHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'VIEW_SALES_REPS'" class="nav-item">
            <a
              [routerLink]="['/salesreps']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>View/Edit Sales Reps</p>
            </a>
          </li>
          <!-- <li  style="background-color: gray;" *hasClaim="'ADD_SALES_REPS'" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="fas fa-plus-square nav-icon"></i>
            <p>Set Market Name</p>
          </a>
        </li>
        <li  style="background-color: gray;" *hasClaim="'ADD_SALES_REPS'" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="fas fa-plus-square nav-icon"></i>
            <p>Set Showroom Mode</p>
          </a>
        </li>
        <li style="background-color: gray;" *hasClaim="'ADD_SALES_REPS'" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="fas fa-plus-square nav-icon"></i>
            <p>Manage Licences</p>
          </a>
        </li> -->
        </ul>
        <!-- <li  style="background-color: gray;" class="nav-item">
        <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
          class="nav-link">
          <i class="far fa-list-alt nav-icon"></i>
          <p>Manage Data</p>
        </a>
      </li>
      <li  style="background-color: gray;" class="nav-item">
        <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
          class="nav-link">
          <i class="far fa-list-alt nav-icon"></i>
          <p>Manage Images</p>
        </a>
      </li>

      <li  style="background-color: gray;" class="nav-item">
        <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
          class="nav-link">
          <i class="far fa-list-alt nav-icon"></i>
          <p>Send Files</p>
        </a>
      </li> -->

      <!-- Add the below when enable this menu -->
      <!-- data-toggle="collapse" -->
      <!-- data-target="#POR" -->
        <li
          id="PORHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          class="collapsed"
          *hasClaim="['POR_VIEW_PO_REQUESTS', 'POR_ADD_PO_REQUEST']"
          [class.disabled]="true"
        >
          <a
            class="nav-link"
            [ngClass]="{ active: currentUrl == 'purchase-order-request' }"
            [class.disabled]="true"
          >
            <i class="nav-icon fas fa-bookmark"></i>
            <span>{{ "PURCHASE_ORDER_REQUEST" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="POR"
          [ngClass]="{ show: currentUrl == 'purchase-order-request' }"
          aria-labelledby="PORHeading"
          data-parent="#accordionExample"
        >
          <li class="nav-item" *hasClaim="'POR_VIEW_PO_REQUESTS'">
            <a
              [routerLink]="['/purchase-order-request/list']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'POR_ADD_PO_REQUEST'">
            <a
              [routerLink]="['/purchase-order-request/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>
        <!-- <li   style="background-color: red;"  id="POHeading" aria-expanded="true" aria-controls="collapseOne" data-toggle="collapse" data-target="#PO"
          class="collapsed" *hasClaim="['PO_VIEW_PURCHASE_ORDERS','PO_ADD_PO']">
          <a class="nav-link" [ngClass]="{'active': currentUrl == 'purchase-order'}">
            <i class="nav-icon fas fa-cart-plus"></i>
            <span>{{'PURCHASE_ORDER' | translate}}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li> -->
        <ul
          class="sub-menu collapse"
          id="PO"
          [ngClass]="{ show: currentUrl == 'purchase-order' }"
          aria-labelledby="POHeading"
          data-parent="#accordionExample"
        >
          <li class="nav-item" *hasClaim="'PO_VIEW_PURCHASE_ORDERS'">
            <a
              [routerLink]="['/purchase-order/list']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'PO_ADD_PO'">
            <a
              [routerLink]="['/purchase-order/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>
        <!-- <li    style="background-color: red;"  id="POREHeading" aria-expanded="true" aria-controls="collapseOne" data-toggle="collapse" data-target="#PORE"
          class="collapsed" *hasClaim="['PO_RETURN_PO']">
          <a class="nav-link" [ngClass]="{'active': currentUrl == 'purchase-order-return'}">
            <i class="nav-icon fas fa-cart-plus"></i>
            <span>{{'PURCHASE_ORDER_RETURN' | translate}}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li> -->
        <ul
          class="sub-menu collapse"
          id="PORE"
          [ngClass]="{ show: currentUrl == 'purchase-order-return' }"
          aria-labelledby="POREHeading"
          data-parent="#accordionExample"
        >
          <li class="nav-item" *hasClaim="'PO_RETURN_PO'">
            <a
              [routerLink]="['/purchase-order-return/list']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'PO_RETURN_PO'">
            <a
              [routerLink]="['/purchase-order-return/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>
        <li
          id="SalesHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          data-target="#Sales"
          class="collapsed"
          *hasClaim="['SO_VIEW_SALES_ORDERS', 'SO_ADD_SO']"
        >
          <a
            class="nav-link"
            [ngClass]="{ active: currentUrl == 'sales-order' }"
          >
            <i class="nav-icon fas fa-cart-arrow-down"></i>
            <span>{{ "SALES_ORDER" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Sales"
          aria-labelledby="SalesHeading"
          [ngClass]="{ show: currentUrl == 'sales-order' }"
          data-parent="#accordionExample"
        >
          <li class="nav-item" *hasClaim="'SO_VIEW_SALES_ORDERS'">
            <a
              [routerLink]="['/sales-order/list']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'SO_ADD_SO'">
            <a
              [routerLink]="['/sales-order/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'CREATE_REAL_TIME_ORDER'">
            <a
              [routerLink]="['/sales-order/realtime']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "CREATE_REAL_TIME_ORDER" | translate }}</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'EXPORT_ORDER'">
            <a
              [routerLink]="['/sales-order/export-orders']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Export Orders</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'DUPLICATE_ORDER'">
            <a
              [routerLink]="['/sales-order/duplicate-orders']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Duplicate Orders</p>
            </a>
          </li>
          <!-- <li  style="background-color: gray;" class="nav-item" *hasClaim="'SO_ADD_SO'">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Export Order</p>
            </a>
          </li>
          <li  style="background-color: gray;" class="nav-item" *hasClaim="'SO_ADD_SO'">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="fas fa-plus-square nav-icon"></i>
              <p>RealTime Order</p>
            </a>
          </li> -->
        </ul>
        <!-- Add the below when enable -->
        <!-- data-toggle="collapse" -->
        <!-- data-target="#SalesReturn" -->
        <li
          id="SalesReHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          class="collapsed"
          *hasClaim="['SO_RETURN_SO']"
          [class.disabled]="true"
        >
          <a
            class="nav-link"
            [ngClass]="{ active: currentUrl == 'sales-order-return' }"
            [class.disabled]="true"
          >
            <i class="nav-icon fas fa-cart-arrow-down"></i>
            <span>{{ "SALES_ORDER_RETURN" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="SalesReturn"
          aria-labelledby="SalesReHeading"
          [ngClass]="{ show: currentUrl == 'sales-order-return' }"
          data-parent="#accordionExample"
        >
          <li class="nav-item" *hasClaim="'SO_RETURN_SO'">
            <a
              [routerLink]="['/sales-order-return/list']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'SO_RETURN_SO'">
            <a
              [routerLink]="['/sales-order-return/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>

        <li *hasClaim="['MANAGE_FILE']" class="nav-item">
          <a
            [routerLink]="['/send-file']"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link"
          >
            <i class="fas fa-file-import"></i>
            <p>Send Files</p>
          </a>
        </li>
        <li *hasClaim="['IMPORT_DATA']" class="nav-item">
          <a
            [routerLink]="['/import-data']"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link"
          >
            <i class="fas fa-file-import"></i>
            <p>Import Data</p>
          </a>
        </li>
        <li *hasClaim="['INVE_VIEW_INVENTORIES']" class="nav-item" [class.disabled]="true">
          <a
            [routerLink]="['/inventory']"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link"
            [class.disabled]="true"
          >
            <i class="far fa-list-alt nav-icon"></i>
            <p>{{ "INVENTORY" | translate }}</p>
          </a>
        </li>
        <!-- Add the below 2 when enable -->
        <!-- data-toggle="collapse" -->
        <!-- data-target="#Expense" -->
        <li
          id="ExpenseHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          class="collapsed"
          [class.disabled]="true"
          *hasClaim="[
            'EXP_VIEW_EXPENSES',
            'EXP_ADD_EXPENSE',
            'EXP_MANAGE_EXP_CATEGORY'
          ]"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'expense' }" [class.disabled]="true">
            <i class="fas fa-solid fa-wallet nav-icon"></i>
            <span>{{ "EXPENSE" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Expense"
          [ngClass]="{ show: currentUrl == 'expense' }"
          aria-labelledby="ExpenseHeading"
          data-parent="#accordionExample"
        >
          <li class="nav-item" *hasClaim="'EXP_VIEW_EXPENSES'">
            <a
              [routerLink]="['/expense']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "LIST" | translate }}
              </p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'EXP_ADD_EXPENSE'">
            <a
              [routerLink]="['/expense/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>
                {{ "ADD_NEW" | translate }}
              </p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'EXP_MANAGE_EXP_CATEGORY'">
            <a
              [routerLink]="['/expense-category']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "EXPENSE_CATEGORY" | translate }}
              </p>
            </a>
          </li>
        </ul>
        <li
          id="ReportsHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          data-target="#Reports"
          class="collapsed"
          *hasClaim="[
            'REP_PO_REP',
            'REP_SO_REP',
            'REP_PO_PAYMENT_REP',
            'REP_EXPENSE_REP',
            'REP_SO_PAYMENT_REP',
            'REP_SALES_VS_PURCHASE_REP',
            'REP_PRO_PP_REP',
            'REP_PRO_SO_REPORT',
            'REP_STOCK_REPORT',
            'REP_SUP_PAYMENT_REP',
            'REP_CUST_PAYMENT_REP',
            'REP_VIEW_PRO_LOSS_REP',
            'SALES_BY_CUSTOMER',
            'VIEW_SALES_REPS_RANKING',
            'SALES_BY_CATEGORY',
            'SALES_BY_PRODUCT_CATEGORY',
            'SALES_OVER_TIME',
            'SALES_BY_CATEGORY_BREAKDOWN',
            'CUSTOMER_INVENTORY_REPORT',
            'SALES_BY_REPORT_CATEGORY',
            'PRODUCT_IN_STOCK',
            'BEST_SELLER_PRODUCT_LISTING',
            'BEST_SELLER_CATEGORY_LISTING',
            'SALES_REPS_SUMMARY',
            'CUSTOMER_BASE_REPORT'
          ]"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'report' }">
            <i class="nav-icon fas fa-chart-bar"></i>
            <span>{{ "REPORTS" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Reports"
          aria-labelledby="ReportsHeading"
          [ngClass]="{ show: currentUrl == 'report' }"
          data-parent="#accordionExample"
        >
          <!-- <li  style="background-color:  red;"  *hasClaim="'REP_PO_REP'" class="nav-item">
            <a [routerLink]="['/purchase-order-report']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact:true}" class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{'PURCHASE_ORDER_REPORT' | translate}}
              </p>
            </a>
          </li> -->
          <li *hasClaim="'REP_SO_REP'" class="nav-item">
            <a
              [routerLink]="['/sales-order-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_ORDER_REPORT" | translate }}
              </p>
            </a>
          </li>

          <!-- <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sales History Search By Sales Reps Reports
              </p>
            </a>
          </li>

          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Best Seller Listing Reports
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals Over Time
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals Reps Ranking
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals By Category
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals By Report Category
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals By Category w/ Breakdown
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals By Product
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals By Product By Category
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals By Customer
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Sals Summary
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Product In Stock
              </p>
            </a>
          </li>
          <li  style="background-color:  gray;" class="nav-item">
            <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                Customer Inventory Report
              </p>
            </a>
          </li>
          <li  style="background-color:  red;" *hasClaim="'REP_PRO_PP_REP'" class="nav-item">
            <a [routerLink]="['/product-purchase-report']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact:true}" class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{'PRODUCT_PURCHASE_REPORT' | translate}}
              </p>
            </a>
          </li> -->
          <li *hasClaim="'REP_PRO_SO_REPORT'" class="nav-item">
            <a
              [routerLink]="['/product-sales-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "PRODUCT_SALES_REPORT" | translate }}
              </p>
            </a>
          </li>
          <!-- <li  style="background-color:  red;"  *hasClaim="'REP_VIEW_WAR_REP'" class="nav-item">
            <a [routerLink]="['/product-warehouse-report']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact:true}" class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{'PRODUCT_WAREHOUSE_REPORT' | translate}}
              </p>
            </a>
          </li> -->
          <li *hasClaim="'REP_STOCK_REPORT'" class="nav-item">
            <a
              [routerLink]="['/stock-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "STOCK_REPORT" | translate }}
              </p>
            </a>
          </li>
          <!-- <li  style="background-color:  red;" *hasClaim="'REP_PO_PAYMENT_REP'" class="nav-item">
            <a [routerLink]="['/purchase-payment-report']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact:true}" class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{'PURCHASE_PAYMENT_REPORT' | translate}}
              </p>
            </a>
          </li> -->
          <li *hasClaim="'REP_SO_PAYMENT_REP'" class="nav-item">
            <a
              [routerLink]="['/sales-payment-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_PAYMENT_REPORT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'REP_EXPENSE_REP'" class="nav-item">
            <a
              [routerLink]="['/expense-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "EXPENSE_REPORT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'REP_VIEW_PRO_LOSS_REP'" class="nav-item">
            <a
              [routerLink]="['/profit-loss-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "PROFIT_VS_LOSS_REPORT" | translate }}
              </p>
            </a>
          </li>
          <!-- <li  style="background-color:  red;" *hasClaim="'REP_SALES_VS_PURCHASE_REP'" class="nav-item">
            <a [routerLink]="['/sales-purchase-report']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact:true}" class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{'SALES_VS_PURCHASE' | translate}}
              </p>
            </a>
          </li>
          <li  style="background-color:  red;" *hasClaim="'REP_SUP_PAYMENT_REP'" class="nav-item">
            <a [routerLink]="['/supplier-payment-report']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact:true}" class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{'SUPPLIER_PAYMENT_REPORT' | translate}}
              </p>
            </a>
          </li> -->
          <li *hasClaim="'REP_CUST_PAYMENT_REP'" class="nav-item">
            <a
              [routerLink]="['/customer-payment-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "CUSTOMER_PAYMENT_REPORT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'SALES_BY_CUSTOMER'" class="nav-item">
            <a
              [routerLink]="['/sales-by-customer']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_BY_CUSTOMER" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'VIEW_SALES_REPS_RANKING'" class="nav-item">
            <a
              [routerLink]="['/sales-reps-ranking-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_REP_RANKING_REPORT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'SALES_BY_CATEGORY'" class="nav-item">
            <a
              [routerLink]="['/sales-by-category']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_BY_CATEGORY" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'SALES_BY_PRODUCT_CATEGORY'" class="nav-item">
            <a
              [routerLink]="['/sales-by-product-category-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_BY_PRODUCT_CATEGORY_REPORT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'SALES_OVER_TIME'" class="nav-item">
            <a
              [routerLink]="['/sales-over-time-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_OVER_TIME_REPORT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'SALES_BY_CATEGORY_BREAKDOWN'" class="nav-item">
            <a
              [routerLink]="['/sales-by-category-breakdown']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_BY_CATEGORY_W_BREAKDOWN_REPORT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'CUSTOMER_INVENTORY_REPORT'" class="nav-item">
            <a
              [routerLink]="['/customer-inventory-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "CUSTOMER_INVENTORY_REPORT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'SALES_BY_REPORT_CATEGORY'" class="nav-item">
            <a
              [routerLink]="['/sales-by-report-category']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_BY_REPORT_CATEGORY" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'PRODUCT_IN_STOCK'" class="nav-item">
            <a
              [routerLink]="['/product-in-stock']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "PRODUCT_IN_STOCK" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'BEST_SELLER_PRODUCT_LISTING'" class="nav-item">
            <a
              [routerLink]="['/best-seller-product']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "BEST_SELLER_PRODUCT" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'BEST_SELLER_CATEGORY_LISTING'" class="nav-item">
            <a
              [routerLink]="['/best-seller-category']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "BEST_SELLER_CATEGORY" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'SALES_HISTORY_SEARCH_SALESREPS'" class="nav-item">
            <a
              [routerLink]="['/sales-history-by-sales-representative']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Sales History By Sales Representative</p>
            </a>
          </li>

          <li *hasClaim="'SALES_REPS_SUMMARY'" class="nav-item">
            <a
              [routerLink]="['/sales-rep-summary']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "SALES_REP_SUMMARY_REPORT" | translate }}
              </p>
            </a>
          </li>

          <li *hasClaim="'CUSTOMER_BASE_REPORT'" class="nav-item">
            <a
              [routerLink]="['/customer-base-report']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "CUSTOMER_BASE_REPORT" | translate }}
              </p>
            </a>
          </li>
          <!-- <li  style="background-color:  red;" *hasClaim="'REP_VIEW_WAR_REP'" class="nav-item">
            <a [routerLink]="['/warehouse-report']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{'WAREHOUSE_REPORT' | translate}}
              </p>
            </a>
          </li> -->
        </ul>
        <!-- For Inquiry when need to enable then add the below 2 commented in the li -->
        <!-- data-toggle="collapse" -->
        <!-- data-target="#Inquiry" -->
        <li
          id="InquiryHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['INQ_VIEW_INQUIRIES', 'INQ_ADD_INQUIRY']"
          class="collapsed"
          [class.disabled]="true"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'inquiry' }" [class.disabled]="true">
            <i class="nav-icon fas fa-question-circle"></i>
            <span>{{ "INQUIRY" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Inquiry"
          [ngClass]="{ show: currentUrl == 'inquiry' }"
          aria-labelledby="InquiryHeading"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'INQ_VIEW_INQUIRIES'" class="nav-item">
            <a
              [routerLink]="['/inquiry']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'INQ_ADD_INQUIRY'" class="nav-item">
            <a
              [routerLink]="['/inquiry/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'INQ_MANAGE_INQ_STATUS'" class="nav-item">
            <a
              [routerLink]="['/inquiry-status']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "INQUIRY_STATUS" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'INQ_MANAGE_INQ_SOURCE'" class="nav-item">
            <a
              [routerLink]="['/inquiry-source']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "INQUIRY_SOURCES" | translate }}</p>
            </a>
          </li>
        </ul>
        <li
          id="ReminderHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['REM_VIEW_REMINDERS', 'REM_ADD_REMINDER']"
          data-toggle="collapse"
          data-target="#Reminder"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'reminders' }">
            <i class="far fa-bell nav-icon"></i>
            <span>{{ "REMINDER" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Reminder"
          aria-labelledby="ReminderHeading"
          [ngClass]="{ show: currentUrl == 'reminders' }"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'REM_VIEW_REMINDERS'" class="nav-item">
            <a
              [routerLink]="['/reminders']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>
                {{ "LIST" | translate }}
              </p>
            </a>
          </li>
          <li *hasClaim="'REM_ADD_REMINDER'" class="nav-item">
            <a
              [routerLink]="['/reminders/add']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>
                {{ "ADD_NEW" | translate }}
              </p>
            </a>
          </li>
        </ul>

        <li
          id="NotificationHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          data-target="#Notification"
          class="collapsed"
          *hasClaim="['NOTIF_ADD_NOTIFICATION', 'NOTIF_UPDATE_NOTIFICATION']"
        >
          <a
            class="nav-link"
            [ngClass]="{ active: currentUrl == 'notifications' }"
          >
            <i class="fas fa-stopwatch nav-icon"></i>
            <span>{{ "NOTIFICATIONS" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Notification"
          aria-labelledby="NotificationHeading"
          [ngClass]="{ show: currentUrl == 'notifications' }"
          data-parent="#accordionExample"
        >
          <li class="nav-item" *hasClaim="['NOTIF_ADD_NOTIFICATION', 'NOTIF_UPDATE_NOTIFICATION']">
            <a
              [routerLink]="['notifications/reminder-notification']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-stopwatch nav-icon"></i>
              <p>Reminder Notification</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="['NOTIF_ADD_NOTIFICATION', 'NOTIF_UPDATE_NOTIFICATION']">
            <a
              [routerLink]="['notifications/notification']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-stopwatch nav-icon"></i>
              <p>Notification</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'NOTIF_ADD_NOTIFICATION'">
            <a
              [routerLink]="['notifications/add-notification']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>Add New Notification</p>
            </a>
          </li>
        </ul>

        <li
          id="RolesHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['ROLES_VIEW_ROLES', 'ROLES_ADD_ROLE']"
          data-toggle="collapse"
          data-target="#Roles"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'roles' }">
            <i class="nav-icon fas fa-users-cog"></i>
            <span>{{ "ROLES" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Roles"
          aria-labelledby="RolesHeading"
          [ngClass]="{ show: currentUrl == 'roles' }"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'ROLES_VIEW_ROLES'" class="nav-item">
            <a
              [routerLink]="['/roles']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'ROLES_ADD_ROLE'" class="nav-item">
            <a
              [routerLink]="['/roles/manage']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
        </ul>
        <li
          id="UsersHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="[
            'USR_VIEW_USERS',
            'USR_ADD_USER',
            'USR_ASSIGN_USR_ROLES',
            'USR_ONLINE_USERS'
          ]"
          data-toggle="collapse"
          data-target="#Users"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'users' }">
            <i class="nav-icon fa fa-users"></i>
            <span>{{ "USERS" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>

        <!-- <li style="background-color: gray;" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="far fa-list-alt nav-icon"></i>
            <p>DataSynq Agent</p>
          </a>
        </li>
        <li style="background-color: gray;" class="nav-item">
          <a  routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            class="nav-link">
            <i class="far fa-list-alt nav-icon"></i>
            <p>Accept Payments</p>
          </a>
        </li> -->
        <ul
          class="sub-menu collapse"
          id="Users"
          aria-labelledby="UsersHeading"
          [ngClass]="{ show: currentUrl == 'users' }"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'USR_VIEW_USERS'" class="nav-item">
            <a
              [routerLink]="['/users']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LIST" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'USR_ADD_USER'" class="nav-item">
            <a
              [routerLink]="['/users/manage']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-plus-square nav-icon"></i>
              <p>{{ "ADD_NEW" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'USR_ASSIGN_USR_ROLES'" class="nav-item">
            <a
              [routerLink]="['/roles/users']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-user-shield nav-icon"></i>
              <p>{{ "USER_ROLES" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'USR_ONLINE_USERS'" class="nav-item">
            <a
              [routerLink]="['/sessions']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="nav-icon fa fa-chalkboard-teacher"></i>
              <p>
                {{ "CURRENT_ONLINE_USERS" | translate }}
              </p>
            </a>
          </li>
        </ul>
        <li
          id="EmailHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="[
            'EMAIL_MANAGE_EMAIL_SMTP_SETTINS',
            'EMAIL_MANAGE_EMAIL_TEMPLATES',
            'EMAIL_SEND_EMAIL'
          ]"
          data-toggle="collapse"
          data-target="#Email"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'email' }">
            <i class="nav-icon fas fa-envelope-open-text"></i>
            <span>{{ "EMAIL" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Email"
          aria-labelledby="EmailHeading"
          [ngClass]="{ show: currentUrl == 'email' }"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'EMAIL_MANAGE_EMAIL_SMTP_SETTINS'" class="nav-item">
            <a
              [routerLink]="['/email-smtp']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-cog nav-icon"></i>
              <p>{{ "SMTP_SETTINGS" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'EMAIL_MANAGE_EMAIL_TEMPLATES'" class="nav-item">
            <a
              [routerLink]="['/emailtemplate']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-mail-bulk nav-icon"></i>
              <p>{{ "EMAIL_TEMPLATE" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'EMAIL_SEND_EMAIL'" class="nav-item">
            <a
              [routerLink]="['/send-email']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-paper-plane nav-icon"></i>
              <p>{{ "SEND_EMAIL" | translate }}</p>
            </a>
          </li>
        </ul>
        <li
          id="SettingsHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          data-toggle="collapse"
          *hasClaim="[
            'SETT_UPDATE_COM_PROFILE',
            'SETT_MANAGE_COUNTRY',
            'SETT_MANAGE_CITY',
            'TERMS_AND_CONDITION',
            'REPSLINK_APP_SETTINGS',
            'PRO_MANAGE_TAX',
            'PRO_MANAGE_UNIT'
          ]"
          data-target="#Settings"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'settings' }">
            <i class="nav-icon fa fa-tools"></i>
            <span>{{ "SETTINGS" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Settings"
          aria-labelledby="SettingsHeading"
          [ngClass]="{ show: currentUrl == 'settings' }"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'SETT_UPDATE_COM_PROFILE'" class="nav-item">
            <a
              [routerLink]="['/company-profile']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-building nav-icon"></i>
              <p>{{ "COMPANY_PROFILE" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'SALESREPS_COMMISSION_MANAGEMENT'" class="nav-item">
            <a
              [routerLink]="['/commission-setting']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="fas fa-building nav-icon"></i>
              <p>{{ "COMMISSION-SETTING" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'SETT_MANAGE_COUNTRY'" class="nav-item">
            <a
              [routerLink]="['/country']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "COUNTRY" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'SETT_MANAGE_CITY'" class="nav-item">
            <a
              [routerLink]="['/cities']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "CITY" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'MANAGE_STATE_PROVINCE'" class="nav-item">
            <a
              [routerLink]="['/state-and-provision']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "STATE_AND_PROVISION" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'MANAGE_MARKETS'" class="nav-item">
            <a
              [routerLink]="['/markets']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "Markets" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'PRO_MANAGE_TAX'" class="nav-item">
            <a
              [routerLink]="['/tax']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "TAX" | translate }}</p>
            </a>
          </li>
          <li class="nav-item" *hasClaim="'PRO_MANAGE_UNIT'">
            <a
              [routerLink]="['/unitConversation']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "UNIT_CONVERSATION" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'PRICE_NAME_SETTINGS'" class="nav-item">
            <a
              [routerLink]="['/price-name-settings']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Price Name Settings</p>
            </a>
          </li>

          <li *hasClaim="'TERMS_AND_CONDITION'" class="nav-item">
            <a
              [routerLink]="['/terms-and-conditions']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>Terms And Conditions</p>
            </a>
          </li>
          <li *hasClaim="'REPSLINK_APP_SETTINGS'" class="nav-item">
            <a
              [routerLink]="['/ezorders-app-settings']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>EzOrders App Settings</p>
            </a>
          </li>
          <!-- <li style="background-color: gray;" class="nav-item">
              <p>Global Settings</p>
            </a>
          </li>
          <li style="background-color: gray;" class="nav-item">
            <a [routerLink]="['/send-email']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="fas fa-paper-plane nav-icon"></i>
              <p>EzOrders App Settings</p>
            </a>
          </li>
          <li style="background-color: gray;" class="nav-item">
            <a [routerLink]="['/send-email']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="fas fa-paper-plane nav-icon"></i>
              <p>Inventory Settings</p>
            </a>
          </li>
          <li style="background-color: gray;" class="nav-item">
            <a [routerLink]="['/send-email']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
              class="nav-link">
              <i class="fas fa-paper-plane nav-icon"></i>
              <p>Template</p>
            </a>
          </li> -->
        </ul>
        <li
          id="LogsHeading"
          aria-expanded="true"
          aria-controls="collapseOne"
          *hasClaim="['LOGS_VIEW_LOGIN_AUDITS', 'LOGS_VIEW_ERROR_LOGS']"
          data-toggle="collapse"
          data-target="#Logs"
          class="collapsed"
        >
          <a class="nav-link" [ngClass]="{ active: currentUrl == 'logs' }">
            <i class="fas fa-exclamation-triangle nav-icon"></i>
            <span>{{ "LOGS" | translate }}</span>
            <span class="fas fa-angle-down rotate-arrow ml-auto"></span>
          </a>
        </li>
        <ul
          class="sub-menu collapse"
          id="Logs"
          aria-labelledby="LogsHeading"
          [ngClass]="{ show: currentUrl == 'logs' }"
          data-parent="#accordionExample"
        >
          <li *hasClaim="'LOGS_VIEW_LOGIN_AUDITS'" class="nav-item">
            <a
              [routerLink]="['/login-audit']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "LOGIN_AUDIT" | translate }}</p>
            </a>
          </li>
          <li *hasClaim="'LOGS_VIEW_ERROR_LOGS'" class="nav-item">
            <a
              [routerLink]="['/logs']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              <i class="far fa-list-alt nav-icon"></i>
              <p>{{ "ERROR_LOGS" | translate }}</p>
            </a>
          </li>
        </ul>
      </ul>
    </div>
  </div>
</div>
